import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useAuth } from 'services/auth-service';
import AccountService, { AccountProps } from 'services/hooks/account-service';
import BuildingService, { BuildingProps } from 'services/hooks/building-service';
import SelectInput from 'components/elements/Form/select/selectInput';
import SelectEntity from 'components/structure/Common/ListsEntity/SelectEntity';

export default function RoleSelectionForm({ Controller, methods }: any) {
  const {
    state: { user }
  } = useAuth();

  const [getAccountByIdResult, setGetAccountByIdResult] = useState<any>(undefined);
  const [getBuildingByIdResult, setGetBuildingByIdResult] = useState<any>();
  const [buildingOptions, setBuildingOptions] = useState<any>([]);
  const formatedOptions = (value: any, label: string) => {
    return { value: value, label: label };
  };

  const { data: accountData, refetch: accountRefetch } = useQuery<AccountProps, Error>(
    'account',
    () => AccountService.findAccountById(user.uuid),
    {
      enabled: !!user.uuid && user.role === 'ACCOUNT',
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  const { data: buildingData, refetch: buildingRefetch } = useQuery<BuildingProps, Error>(
    'building',
    () => BuildingService.findBuildingById(user.uuid),
    {
      enabled: !!user.uuid && user.role === 'BUILDING',
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  useEffect(() => {
    if (accountData && user.uuid && user.role === 'ACCOUNT') {
      accountRefetch();
      setGetAccountByIdResult(accountData);
    }
  }, [accountData, accountRefetch, user]);

  useEffect(() => {
    if (buildingData && user.uuid && user.role === 'BUILDING') {
      buildingRefetch();
      setGetBuildingByIdResult(buildingData);
    }
  }, [buildingData, buildingRefetch, user]);

  // Useeffect when the role is Account
  useEffect(() => {
    if (getAccountByIdResult && user.role === 'ACCOUNT') {
      //To populate building options for Account user
      setBuildingOptions(
        getAccountByIdResult?.buildings?.map((building: { uuid: string; name: string }) =>
          formatedOptions(building?.uuid, building?.name)
        )
      );
    }
  }, [getAccountByIdResult, methods, user.role]);

  // Useeffect when the role is Building
  useEffect(() => {
    if (getBuildingByIdResult && user.role === 'BUILDING') {
      methods.setValue('buildingUuid', getBuildingByIdResult?.uuid);
      //Preload buildingUuid for Building user
      setBuildingOptions([
        formatedOptions(getBuildingByIdResult?.uuid, getBuildingByIdResult?.name)
      ]);
    }
  }, [methods, user.role, getBuildingByIdResult]);

  const renderRoleBasedDetails = () => {
    switch (user.role) {
      case 'SUPER':
        return (
          <SelectEntity
            Controller={Controller}
            control={methods.control}
            label="Choose a Building"
            placeholder="Select Building"
            queryname="buildings"
            name="buildingUuid"
            errors={methods.formState.errors}
            disabled={false}
            query={BuildingService.findAllBuildings}
          />
        );
      case 'ACCOUNT':
        return (
          <SelectInput
            Controller={Controller}
            control={methods.control}
            label="Choose a Building"
            placeholder="Select Building"
            name="buildingUuid"
            errors={methods.formState.errors}
            // disabled={editUUID && true}
            options={buildingOptions}
          />
        );
      case 'BUILDING':
        return (
          <SelectInput
            Controller={Controller}
            control={methods.control}
            label="Choose a Building"
            placeholder="Select Building"
            name="buildingUuid"
            errors={methods.formState.errors}
            disabled={true}
            options={buildingOptions}
          />
        );

      default:
        console.log('Role is missing');
        return null;
    }
  };

  return renderRoleBasedDetails();
}
